import {CodebookModel} from '../models/codebook.model';

export enum BindingTypeEnum {
    cdRom = 1,
    dvd = 2,
    online = 3,
    usb = 4,
    bounded = 5,
    stitched = 6
}

export class BindingTypeCodebook {
    static allTypes: CodebookModel[] = [
        {
            id: BindingTypeEnum.cdRom,
            name: 'BindingType-CD ROM'
        }, {
            id: BindingTypeEnum.dvd,
            name: 'BindingType-DVD'
        }, {
            id: BindingTypeEnum.online,
            name: 'BindingType-on-line'
        }, {
            id: BindingTypeEnum.usb,
            name: 'BindingType-USB'
        }, {
            id: BindingTypeEnum.bounded,
            name: 'BindingType-viazaná'
        }, {
            id: BindingTypeEnum.stitched,
            name: 'BindingType-brožovaná'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/codebook/binding-type-codebook.ts